import React from 'react';
import { BottomSheet, BottomSheetProps } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import * as styles from './styles';

export type BottomSheetModalProps = BottomSheetProps & {
  open: boolean;
};

const BottomSheetModal: React.FC<BottomSheetModalProps> = (props) => {
  const { open = false, children, ...restProps } = props;

  return (
    <BottomSheet
      open={open}
      className={styles.container}
      sibling={
        <div
          data-rsbs-backdrop="true"
          className={styles.bottomSheetSibling}
          onClick={(e) => {
            if (restProps.onDismiss) {
              e.preventDefault();
              e.stopPropagation();
              restProps.onDismiss();
            }
          }}
        />
      }
      blocking={false}
      {...restProps}
    >
      {children}
    </BottomSheet>
  );
};

export default BottomSheetModal;
